import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
import { getIsMobile } from '../../utils/deviceUtils';
import { getACQ134VariantAPostVerificationSteps, preFillHubInterestACQ134 } from '../../experiments/acq134/acq134Utils';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
export const BranchACQ134VariantA = {
  name: 'BranchACQ134VariantA',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0134, [ExperimentParameterGroup.Variant_A]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const {
      preVerification,
      postExistingAccountSelection
    } = getFlowSteps();
    const postVerificationSteps = getACQ134VariantAPostVerificationSteps();
    const postAccountCreationSteps = getIsMobile() ? [Step.MobileAppPrompt] : [];
    preFillHubInterestACQ134(dispatch);
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...postVerificationSteps, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, postVerificationSteps, postAccountCreationSteps, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};